import { useCallback, useState } from 'react';
import { ERROR_MESSAGES, GENERIC_ERROR_MESSAGE, responseAsProblemDetail } from '../utils/error-handler';

export type DecodedApiError = { message: string; code: string };

export function useParseApiError() {
  const [decodedApiError, setDecodedApiError] = useState<DecodedApiError | null>(null);

  const parseApiError = useCallback((error: Error | string) => {
    if (!error) return setDecodedApiError(null);

    try {
      const parsedErrorMessage = typeof error === 'string' ? JSON.parse(error) : error;
      const isProblemDetail = responseAsProblemDetail(parsedErrorMessage);

      if (!isProblemDetail) {
        setDecodedApiError({ message: GENERIC_ERROR_MESSAGE, code: 'UNKNOWN' });
        return;
      }

      setDecodedApiError({
        message: ERROR_MESSAGES[parsedErrorMessage.code] || GENERIC_ERROR_MESSAGE,
        code: parsedErrorMessage.code,
      });
    } catch (e) {
      setDecodedApiError({ message: GENERIC_ERROR_MESSAGE, code: 'UNKNOWN' });
    }
  }, []);

  return { decodedApiError, setDecodedApiError, parseApiError };
}
